import { observer } from "mobx-react-lite";
import { alertDialogStore, actionDialogStore } from "../store/dialogs";
import ActionModal from "../components/Modals/ActionModal";
import { DamsAppAsset } from "../assets/registry";
import { ModalBase } from "../components/Modals/ModalBase";

const PageDialogControllersView = observer(() => {
  const {
    isOpen: isActionDialogOpen,
    isProcessing,
    props: actionProps,
    close: closeActionDialog
  } = actionDialogStore;

  const {
    isOpen: isAlertDialogOpen,
    props: alertProps,
    close: closeAlertDialog
  } = alertDialogStore;

  const handleActionDialogRightPress = async () => {
    actionDialogStore.startProcessing();
    await actionProps.onRightBtnPress?.();
    actionDialogStore.stopProcessing();
    closeActionDialog();
  };

  const handleActionDialogLeftPress = () => {
    actionProps.onLeftBtnPress?.();
    closeActionDialog();
  };

  const handleAlertDialogRightPress = () => {
    alertProps.onRightBtnPress?.();
    closeAlertDialog();
  };

  const handleAlertDialogLeftPress = () => {
    alertProps.onLeftBtnPress?.();
    closeAlertDialog();
  };

  const DEFAULT_CONFIRM_TEXT = "Confirm";
  const DEFAULT_CANCEL_TEXT = "Cancel";

  return (
    <>
      {/* User Action Confirmation Prompt */}
      <ModalBase
        open={isActionDialogOpen}
        title={actionProps.title}
        subtitle={actionProps.subtitle}
        onRightBtnPress={handleActionDialogRightPress}
        rightBtnTxt={actionProps.rightBtnTxt ?? DEFAULT_CONFIRM_TEXT}
        onLeftBtnPress={handleActionDialogLeftPress}
        onRightBtnLoading={isProcessing}
        leftBtnTxt={actionProps.leftBtnTxt ?? DEFAULT_CANCEL_TEXT}
        onClose={closeActionDialog}
        isFullScreen={actionProps.isFullScreen}
        type={"action"}
        showHeader={true}
        leftIcon={
          actionProps.type === "DELETE"
            ? DamsAppAsset.icons.delete_icon
            : actionProps.type === "UPDATE"
              ? DamsAppAsset.icons.edit_item
              : DamsAppAsset.icons.warning
        }
      />

      {/* Function Action Callback Response */}
      <ActionModal
        show={isAlertDialogOpen}
        title={alertProps.title}
        subtitle={alertProps.subtitle}
        onRightBtnPress={handleAlertDialogRightPress}
        rightBtnTxt={alertProps.rightBtnTxt ?? DEFAULT_CONFIRM_TEXT}
        onLeftBtnPress={handleAlertDialogLeftPress}
        leftBtnTxt={alertProps.leftBtnTxt ?? DEFAULT_CANCEL_TEXT}
        onClosePress={closeAlertDialog}
        isFullScreen={alertProps.isFullScreen}
        leftIcon={
          !alertProps.isSuccess ? DamsAppAsset.icons.warning : undefined
        }
      />
    </>
  );
});

export default PageDialogControllersView;
